var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM6.44642 9.39733C6.11358 9.15078 5.64388 9.22074 5.39733 9.55358C5.15078 9.88642 5.22074 10.3561 5.55358 10.6027L8.55358 12.8249C8.81878 13.0213 9.18122 13.0213 9.44642 12.8249L11.9727 10.9536L15.9285 14.25H14.4C13.9858 14.25 13.65 14.5858 13.65 15C13.65 15.4142 13.9858 15.75 14.4 15.75H18C18.4142 15.75 18.75 15.4142 18.75 15V11.6667C18.75 11.2525 18.4142 10.9167 18 10.9167C17.5858 10.9167 17.25 11.2525 17.25 11.6667V13.3987L12.4801 9.42383C12.2144 9.20236 11.8316 9.19141 11.5536 9.39733L9 11.2889L6.44642 9.39733Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingDown);
export default __webpack_public_path__ + "static/media/trending-down.fcac4875c3bd0fe4369c65c626fb26c0.svg";
export { ForwardRef as ReactComponent };